import React from 'react';
import classNames from 'classnames/bind';
import CDNImage from '../../utils/CDNImage';

import styles from './Areas.module.scss';
import SlideDown from '../../components/Hover/SlideDown';

let cx = classNames.bind(styles);

const Areas = () => {
	return (
		<section
			id='areas'
			className={cx({ areas: true, 'hidden lg:block bg-gray-200 mt-10 pt-10 pb-20': true })}
		>
			<div className='container mx-auto  flex flex-col'>
				<h1 className='text-tcn-dark-blue font-Avenir-Black text-4xl py-4'>
					<strong className='font-Avenir-Black text-5xl'>NUESTRAS ÁREAS</strong>
				</h1>
			</div>
			<div className='container mx-auto flex flex-row py-8'>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage className='mx-4' image_name={'Ventas.png'} alt='Ventas' />
					<SlideDown
						title='VENTAS'
						text='Llevamos alimentos deliciosos y nutritivos en las manos de todos a través de nuestros tres (3)
						canales que hacen realidad esta misión (Tradicional, Autoservicios y Canales Especiales) con una
						estrategia clara de acrecentar nuestras marcas y proporcionando un excelente servicio.'
					/>
				</div>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage
						className='mx-4'
						image_name={'Seguridad_y_proteccion.png'}
						alt='Seguridad_y_proteccion'
					/>
					<SlideDown
						title='SEGURIDAD Y PROTECCIÓN'
						text='Somos los responsables de salvaguardar el patrimonio y la integridad física de los colaboradores.'
					/>
				</div>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage
						className='mx-4'
						image_name={'Personas.png'}
						alt='Personas'
					/>
					<SlideDown
						title='PERSONAS'
						text='Creemos en la persona y en su potencial, buscamos colaboradores comprometidos con nuestra visión, que actúen con nuestras creencias y que promuevan una cultura Diversa e Incluyente. Con espacios seguros de trabajo, fomentando el bienestar y tratándonos con nuestra regla de oro.'
					/>
				</div>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage
						className='mx-4'
						image_name={'Marketing.png'}
						alt='Marketing'
					/>
					<SlideDown
						title='MARKETING'
						text='Desarrollamos planes de mercadotecnia, lanzamientos y promociones; elaboramos estrategias para crear marcas que se conecten con los consumidores.'
					/>
				</div>
			</div>
			<div className='container mx-auto flex flex-row py-8'>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage className='mx-4' image_name={'chef.png'} alt='chef' />
					<SlideDown
						title='MANUFACTURA'
						text='Elaboramos alimentos deliciosos y nutritivos con calidad de clase mundial, para entregarlos con oportunidad, en cantidades adecuadas, y con los más altos estándares de higiene y seguridad alimentaria'
					/>
				</div>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage
						className='mx-4'
						image_name={'Administracion_y_finanzas.png'}
						alt='Administracion_y_finanzas'
					/>
					<SlideDown
						title='ADMINISTRACIÓN Y FINANZAS'
						text='Entregamos información financiera que facilite la toma de decisiones en forma oportuna y veraz, además garantizamos la cadena de abastecimiento para que nuestros productos lleguen a las manos de los consumidores.'
					/>
				</div>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage
						className='mx-4'
						image_name={'Logistica.png'}
						alt='Logistica'
					/>
					<SlideDown
						title='LOGÍSTICA'
						text='Desarrollamos estrategias de Planeación del Suministro para distribuir nuestros productos hacia el área comercial satisfaciendo las necesidades de nuestros clientes, mercado y consumidores.'
					/>
				</div>
				<div className='flex flex-col w-1/4 mx-16 justify-start items-center'>
					<CDNImage
						className='mx-4'
						image_name={'Mantenimiento.png'}
						alt='Mantenimiento'
					/>
					<SlideDown
						title='MANTENIMIENTO'
						text='Implementamos mejoras de procesos y herramientas tecnológicas para optimizar el mantenimiento, programas de mejora continua, sustentabilidad y operación segura dentro de nuestras plantas.'
					/>
				</div>
			</div>
		</section>
	);
};

export default Areas;
